

















































































































import { Debounce } from 'lodash-decorators';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import InvoiceService from './InvoiceService'
import { showSnackbar } from '@/services/GlobalSnackbarService';
import InvoiceOcr from '@/models/economy/InvoiceOcr';

@Component
export default class InvoiceOcrForm extends Vue {
  invoiceOcr: InvoiceOcr | null = null;
  error_example = null;
  loading = false;
  ocr_number = '456 + 4';
  ocr_number_contains = [
    { name: 'Invoice number', value: 0 },
    { name: 'Customer number, then invoice number', value: 1 },
    { name: 'Invoice number, then customer number', value: 2 },
    { name: 'Custom template', value: 3 },
  ]
  private created() {
    InvoiceService.getInvoiceOcrSettings().then(response => {
      const data = response.data;
      this.invoiceOcr = new InvoiceOcr(data)
    }).catch(error => {
      showSnackbar(this.$t('Failed to fetch settings!'), 'error', 5000, null, null)
    })
  }

  private saveSettings() {
    InvoiceService.saveInvoiceOcrSettings(this.invoiceOcr.formToModel()).then(response => {
      showSnackbar(this.$t('Successfully saved'), 'success', 5000, null, null)
    }).catch((error) => {
      showSnackbar(this.$t('Failed to save!'), 'error', 5000, null, null)
    })
  }

  private goBack() {
    this.$router.back();
  }

 @Watch('invoiceOcr', { deep: true })
  onInputChange() {
    this.loading = true;
    this.debouncedFetch();
  }

  @Debounce(600)
  debouncedFetch() {
    InvoiceService.fetchInvoiceExample(this.invoiceOcr.formToModel())
      .then(response => {
        response = response.data;
        this.ocr_number = response.data.ocrNumber;
        this.error_example = null;
      })
      .catch(err => {
        this.error_example = err;
      })
      .finally(() => {
        this.loading = false;
      });
  }


}

